import AccountAdminService from '@/api/admin/accountAdmin.service'

export default {
  state: {
    table: {
      pageLength: 10,
      rows: [],
      totalRecords: 0,
      searchTerm: '',
    },
    accountToDelete: {},
    accountModel: {},
    editAccountModel: {},
    accountStatuses: {},
  },
  getters: {
    allAccounts: state => state.table,
    accountToDelete: state => state.accountToDelete,
    getAccountModel: state => state.accountModel,
    getEditAccountModel: state => state.editAccountModel,
    getAccountStatuses: state => state.accountStatuses,
  },
  actions: {
    async getAccounts({ commit }) {
      const accounts = await AccountAdminService.getAccounts()
      commit('SET_ACCOUNTS', accounts)
      commit('SET_ACCOUNT_STATUSES', accounts)
      commit('SET_TOTAL_RECORDS', accounts.totalRecords)
      commit('SET_ACCOUNT_MODEL', accounts)
    },
    async getFilteredAccounts({ commit }, wrapper) {
      const accounts = await AccountAdminService.getFilteredAccounts(wrapper)
      commit('SET_ACCOUNTS', accounts)
      commit('SET_ACCOUNT_STATUSES', accounts)
      commit('SET_TOTAL_RECORDS', accounts.totalRecords)
      commit('SET_ACCOUNT_MODEL', accounts)
    },
  },
  mutations: {
    SET_ACCOUNTS(state, accounts) {
      state.table.rows = accounts.accounts
    },
    SET_ACCOUNT_STATUSES(state, accounts) {
      state.accountStatuses = accounts.statuses
    },
    SET_ACCOUNT_TO_DELETE(state, account) {
      state.accountToDelete = account
    },
    SET_TOTAL_RECORDS(state, totalRecords) {
      state.table.totalRecords = totalRecords
    },
    SET_ACCOUNT_MODEL(state, accountModel) {
      state.accountModel = accountModel
    },
    SET_EDIT_ACCOUNT_MODEL(state, editAccountModel) {
      state.editAccountModel = editAccountModel
    },
  },
}
